// extracted by mini-css-extract-plugin
export default {"blog":"blog_blog__R0vSa","blogHeader":"blog_blogHeader__IZhC5","info":"blog_info__Uy2j0","avtarContainer":"blog_avtarContainer__XAHgC","blogsSec":"blog_blogsSec__35NMA"};